<script setup lang="tsx">
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue'
import { commonProps } from './props'
import ClearButton from './ClearButton.vue'
import Multiselect from 'vue-multiselect'
import type { ModuleGroup, Response } from '@/models/api-generated'
import http from '@/services/http'
import type { Column } from '@/stores/column'

const isLoading = ref(false)
const isOpen = ref(false)
const model = defineModel<Column>({ required: true })
const props = defineProps(commonProps)
const options = ref<any[]>([])

const internalModel = computed<string[]>({
	get: () => model.value.filter,
	set: (value) => {
		model.value.filter = value
	},
})

onBeforeUnmount(() => (model.value.filter = []))
onBeforeMount(async () => {
	isLoading.value = true

	const { data } = await http.get<Response<ModuleGroup[]>>('api/module/listGroups')

	options.value = data.data ?? []

	isLoading.value = false
})
</script>

<template>
	<Multiselect
		:multiple="true"
		:show-labels="false"
		:hide-selected="true"
		:close-on-select="false"
		:clear-on-select="false"
		:id="props.id"
		:disabled="props.disabled"
		:placeholder="model.label + '...'"
		:options="options"
		:preserve-search="true"
		:show-no-results="false"
		:loading="isLoading"
		v-model="internalModel"
		:group-select="true"
		group-label="group"
		group-values="modules"
		@open="isOpen = true"
		@close="isOpen = false"
		:limit="isOpen ? 100 : 3"
	>
		<template #clear>
			<ClearButton right="2rem" v-if="internalModel.length" @click="internalModel = []"></ClearButton>
		</template>

		<template v-if="!isOpen" #limit>
			<strong class="multiselect__strong">{{ $t('misc.limit', [internalModel.length - 3]) }}</strong>
		</template>
	</Multiselect>
</template>
